// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"9870c28c","428":"7cf83069","681":"7cf83069","727":"eda9047a","804":"7cf83069","895":"eda9047a"}[chunkId] + ".chunk.css";
};